import {
  ApplyCouponAPIResponse,
  ApplyCouponAPISuccess,
  RemoveCouponAPIResponse,
  RemoveCouponAPISuccess,
  UpdateLineItemAPIResponse,
  UpdateLineItemAPISuccess,
} from './types';

export const isUpdateLineItemAPISuccess = (
  response: UpdateLineItemAPIResponse
): response is UpdateLineItemAPISuccess => 'cart' in response;

export const isApplyCouponAPISuccess = (
  response: ApplyCouponAPIResponse
): response is ApplyCouponAPISuccess => 'cart' in response;

export const isRemoveCouponAPISuccess = (
  response: RemoveCouponAPIResponse
): response is RemoveCouponAPISuccess => 'cart' in response;
